import { useState, useEffect } from 'react';

// import MonitoringMetrics from '../../shared/models/examples/dashboard/monitoring-metrics.json';

import { CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';

import Loader from 'shared/containers/Loader';
import { APIErrorT } from 'shared/models/api';
import {
  DashboardConfigurationT,
  DashboardMonitoringItemT,
  DashboardMonitoringT,
} from 'shared/models/dashboard';
import api from 'utils/api';
import hooks from 'utils/hooks';

import './Dashboard.scss';

import GeneralInformations from './components/GeneralInformations';
import GeneralMonitoring from './components/GeneralMonitoring';
import PacketsTraffic from './components/PacketsTraffic';
import Timeline from './components/Timeline';

function Dashboard() {
  const [isLoading, setIsLoading] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [timelineState, setTimelineState] = useState(0);
  const [configData, setConfigData] = useState<DashboardConfigurationT>();
  const [monitoringData, setMonitoringData] = useState<DashboardMonitoringT>();
  const [timelineMonitoringData, setTimelineMonitoringData] = useState<DashboardMonitoringItemT>();

  const translateTimelineStateIntoKeyName = (timelineValue: number) => {
    switch (timelineValue) {
      case 0:
        return 'lastMinute';
      case 5:
        return 'last5Minutes';
      case 15:
        return 'last15Minutes';
      case 24:
        return 'dayMinus1';
      case 48:
        return 'dayMinus2';
      default:
        return 'lastMinute';
    }
  };

  const apiCallMonitoring = (isRefresh?: boolean) => {
    api.dashboard.monitoring()
      .then((resp: any) => {
        if (resp.status >= 400) {
          resp.json()
            .then((error: APIErrorT) => {
              toast.error(error?.message);
              if (!isRefresh) {
                setIsLoading((count) => count + 1);
              } else {
                setIsRefreshing(false);
              }
            });
        } else {
          resp.json()
            .then((data: DashboardMonitoringT | any) => {
              // eslint-disable-next-line max-len
              // const newData: any = MonitoringMetrics; // Example data for testing
              const newData = data;
              setMonitoringData(newData);
              setTimelineMonitoringData(newData[translateTimelineStateIntoKeyName(timelineState)]);
              if (!isRefresh) {
                setIsLoading((count) => count + 1);
              } else {
                setIsRefreshing(false);
              }
            });
        }
      });
  };

  useEffect(() => {
    api.dashboard.configuration()
      .then((resp: any) => {
        if (resp.status >= 400) {
          resp.json()
            .then((error: APIErrorT) => {
              toast.error(error?.message);
              setIsLoading((count) => count + 1);
            });
        } else {
          resp.json()
            .then((data: DashboardConfigurationT) => {
              setConfigData(data);
              setIsLoading((count) => count + 1);
            });
        }
      });
    apiCallMonitoring();
  }, []);

  const delay = 1000 * 60;
  hooks.useInterval(() => {
    setIsRefreshing(true);
    apiCallMonitoring(true);
  }, delay);

  if (isLoading < 2) {
    return <Loader.Page />;
  }
  return (
    <div className="dashboard">
      <div className="title__header">
        <h1>Dashboard</h1>
      </div>
      <div style={{ overflow: 'scroll', height: '100%', overflowX: 'hidden' }}>
        <GeneralInformations data={configData} />
        <GeneralMonitoring data={timelineMonitoringData} />
        <PacketsTraffic data={timelineMonitoringData} />
      </div>
      <Timeline
        onChange={(newValue: number) => {
          setTimelineState(newValue);
          setTimelineMonitoringData((monitoringData as any)[
            translateTimelineStateIntoKeyName(newValue)
          ]);
        }}
      />
      {
        isRefreshing
          ? (
            <div className="dashboard__refresh box">
              <CircularProgress size="3.5rem" color="secondary" />
            </div>
          )
          : null
      }
    </div>
  );
}

export default Dashboard;
